// extracted by mini-css-extract-plugin
export default {"icon":"ExpandIcon_icon__ec9it","expanded":"ExpandIcon_expanded__TWmMj"};